import { render, staticRenderFns } from "./IPViewNew.vue?vue&type=template&id=8b5eb942&scoped=true&lang=pug&"
import script from "./IPViewNew.vue?vue&type=script&lang=js&"
export * from "./IPViewNew.vue?vue&type=script&lang=js&"
import style0 from "./IPViewNew.vue?vue&type=style&index=0&id=8b5eb942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5eb942",
  null
  
)

export default component.exports